import * as XLSX from 'xlsx';

export interface ExcelColumn {
  key: string;
  label: string;
}

export const exportToExcel = (
  columns: ExcelColumn[],
  rows: Array<Record<string, any>>,
  filename: string,
  sheetName = 'Dados'
) => {
  const header = columns.map((c) => c.label);
  const data = rows.map((row) =>
    columns.map((c) => {
      const v = row[c.key];
      if (v === undefined || v === null) return '';
      if (typeof v === 'object') return JSON.stringify(v);
      return v;
    })
  );
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  ws['!cols'] = columns.map((c) => ({ wch: Math.max(c.label.length + 2, 16) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
};

export interface TemplateField {
  label: string;
  example?: string;
}

export const downloadTemplate = (
  filename: string,
  sheetName: string,
  fields: TemplateField[]
) => {
  const header = fields.map((f) => f.label);
  const example = fields.map((f) => f.example ?? '');
  const ws = XLSX.utils.aoa_to_sheet([header, example]);
  ws['!cols'] = fields.map((f) => ({ wch: Math.max(f.label.length + 2, 16) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
};
